/**************
 Global
 ***************/

//add new product to cart
//let formData = { quantity: 1, id: 794864229, properties: { 'Personalize': 'ZHM' } };
function addProduct(formData) {
    return fetch(`${Shopify.routes.root}cart/add.js`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(data => data.json());
}

//change an existing product in your cart
//let formData = { quantity: 1, id: 794864229 } or items: [{ quantity: 1, id: 794864229 }]
function changeCart(formData) {
    return fetch(`${Shopify.routes.root}cart/change.js`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(data => data.json());
}

//update cart note or attributes (_ for attributes are hidden and __ are private)
//let formData = { note: 'This is a note about my order', attributes: { 'Gift wrap': 'Yes' } }
//let formData = {updates: { 794864229: 2, 794864230: 3 }}
function updateCart(formData) {
    return fetch(`${Shopify.routes.root}cart/update.js`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(data => data.json());
}

// download product
function downloadProduct(handle) {
    return fetch(`${Shopify.routes.root}products/${handle}.js`)
        .then(data => data.json());
}

// get cart
function getCart() {
    return fetch(`${Shopify.routes.root}cart.js`)
        .then(data => data.json());
}

// print price (515491 => $5,154.91)
function price(amountInCents, removeTrailingZeros = false) {
    // calculate total
    let total = (parseFloat(amountInCents) / 100).toFixed(2).toString();

    // add commas if needed
    total = total.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    // remove trailing zeros
    if (removeTrailingZeros) {
        total = total.toString().replace(".00", "");
    }

    // return total
    return `${currency}${total}`;
}

// sleep
function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

/**************
 Design mode open mini cart
 ***************/

if (Shopify.designMode) {
    // if a user clicks on the mini cart
    document.addEventListener('shopify:section:select', function (event) {
        // open mini cart
        if (event.detail.sectionId === 'theme-mini-cart') {
            openCart();
        }

        // if they deselect the mini cart
        if (event.detail.sectionId !== 'theme-mini-cart') {
            closeCart();
        }
    });
}

// scroll to url hash
const maltertechParams = new URLSearchParams(window.location.search);

if (maltertechParams.get("scroll_to_class")) {
    const element = document.querySelector(`.${maltertechParams.get("scroll_to_class")}`);
    if (element) {
        window.scrollTo({
            behavior: 'smooth',
            top: element.offsetTop - 120,
        })
    }
}

if (maltertechParams.get("scroll_to_id")) {
    const element = document.querySelector(`#${maltertechParams.get("scroll_to_id")}`);
    if (element) {
        window.scrollTo({
            behavior: 'smooth',
            top: element.offsetTop - 120,
        })
    }
}

/**************
 Clear abandoned gift box
 ***************/

// a gift box only sells from the gift box pages on the way to checkout, so one left in the cart is abandoned
const GIFT_BOX_PRODUCT_ID = 15409900355735;

// check cart on reload or new page
window.addEventListener("pageshow", async function (event) {
    // a page reached with back or forward holds the cart from before the gift box was added, so ask for it again
    const backForward = event.persisted || performance.getEntriesByType("navigation")[0]?.type === "back_forward";
    if (backForward) {
        cart = await getCart();
    }

    if (!cart.items.some(item => item.product_id === GIFT_BOX_PRODUCT_ID)) {
        return;
    }
    console.log(cart);
    // empty the cart
    cart = await fetch(`${Shopify.routes.root}cart/clear.js`, {method: "POST"})
        .then(response => response.json());

    // update the header cart count
    const headerCart = document.querySelector("#headerIconsCart");
    headerCart.setAttribute("data-count", "0");
    headerCart.setAttribute("aria-label", `View Cart, 0 items`);
});

// Function to send back in stock subscription to Klaviyo
async function sendKlaviyoBackInStockRequest(emailAddress, variantID, phoneNumber = null) {
    const companyId = await klaviyo.account();
    // if sms is included, must also send consent verification
    const requests = [];

    // variables to hold possibly email and phone content
    const channels = ["EMAIL"];
    const profileAttributes = {email: emailAddress};

    // check for number
    if (phoneNumber) {
        channels.push("SMS");
        profileAttributes.phone_number = phoneNumber;
    }

    // set up payload, main request
    const stockPayload = {
        data: {
            type: "back-in-stock-subscription",
            attributes: {
                channels: channels,
                profile: {
                    data: {
                        type: "profile",
                        attributes: profileAttributes
                    }
                }
            },
            relationships: {
                variant: {
                    data: {
                        type: "catalog-variant",
                        id: `$shopify:::$default:::${variantID}`
                    }
                }
            }
        }
    };

    // first main request
    const bisRequest = fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=${companyId}`, {
        method: 'POST',
        headers: {
            'accept': 'application/vnd.api+json',
            'revision': '2024-10-15',
            'content-type': 'application/vnd.api+json'
        },
        body: JSON.stringify(stockPayload)
    });

    requests.push(bisRequest);

    // if number, creat second payload and request for the consent
    if (phoneNumber) {
        const consentPayload = {
            data: {
                type: "subscription",
                attributes: {
                    custom_source: "Back in Stock",
                    profile: {
                        data: {
                            type: "profile",
                            attributes: {
                                email: emailAddress,
                                phone_number: phoneNumber
                            }
                        }
                    }
                },
                relationships: {
                    list: {
                        data: {
                            type: "list",
                            id: "UfarRM"
                        }
                    }
                }
            }
        };

        const consentRequest = fetch(`https://a.klaviyo.com/client/subscriptions?company_id=${companyId}`, {
            method: 'POST',
            headers: {
                'accept': 'application/vnd.api+json',
                'revision': '2024-10-15',
                'content-type': 'application/vnd.api+json'
            },
            body: JSON.stringify(consentPayload)
        });

        requests.push(consentRequest);
    }

    // send in back in stock and consent if present
    try {
        const responses = await Promise.all(requests);

        responses.forEach(res => {
            if (!res.ok) {
                console.error("Klaviyo API Error:", res.status, res.statusText);
            }
        });

    } catch (error) {
        console.error("Fetch request failed:", error);
    }
}

// email validator
function validateEmail(email) {
    const re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
    return re.test(email);
}

// format number
function formatPhoneNumberE164(rawNumber, countryCode = '1') {
    if (!rawNumber) return null;

    // strips number and check for country code
    const cleaned = rawNumber.replace(/\D/g, '');

    if (cleaned.length === 11 && cleaned.startsWith(countryCode)) {
        return `+${cleaned}`;
    }

    if (cleaned.length === 10) {
        return `+${countryCode}${cleaned}`;
    }
    // fall back
    return null;
}